import Import from '@/services/import'
import ImportInvoice from '@/services/import_invoice'
import { formatErrors } from '@utils/errors-alert'
import { bus } from '@/plugins/event-bus'

const fetch = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Import.invoices().then((response) => {
      commit('SET_LIST', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const destroy = async (context, id) => {
  return new Promise((resolve, reject) => {
    ImportInvoice.delete(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const find = async ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    ImportInvoice.find(id).then((response) => {
      commit('SET_GRAPH_INVOICES', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const findInvoices = async ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    ImportInvoice.findInvoices(id).then((response) => {
      commit('SET_INVOICES_LIST', response.data.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const save = (context, payload) => {
  return new Promise(async (resolve, reject) => {
    ImportInvoice.save(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
      reject(error)
    })
  })
}

const rebuild = async (context, id) => {
  return new Promise((resolve, reject) => {
    ImportInvoice.rebuild(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const sendEvaluationCerc = async (context, id) => {
  return new Promise((resolve, reject) => {
    ImportInvoice.sendEvaluationCerc(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

export default {
  fetch,
  find,
  save,
  destroy,
  findInvoices,
  rebuild,
  sendEvaluationCerc
}



// WEBPACK FOOTER //
// ./src/features/import_invoices/store/actions.js